(() => {
  'use strict';
  const section=document.querySelector('[data-beam-scroll]'), sequence=window.BeamSequence;
  if(!section||!sequence)return;
  const stage=section.querySelector('.beam-scroll-stage'), image=section.querySelector('.beam-scroll-image');
  const chapters=[...section.querySelectorAll('.beam-scroll-chapter')],buttons=[...section.querySelectorAll('[data-beam-chapter]')];
  const angle=section.querySelector('[data-beam-angle]'),status=section.querySelector('.beam-scroll-status'),cutScene=section.querySelector('.beam-cut-scene');
  const mobile=matchMedia('(max-width:749px)').matches;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)'),connection=navigator.connection;
  const canvas=document.createElement('canvas');canvas.className='beam-scroll-image beam-scroll-canvas';canvas.setAttribute('aria-hidden','true');
  canvas.style.cssText='position:absolute;inset:0;display:none;pointer-events:none';
  const context=canvas.getContext('2d',{alpha:true});image.after(canvas);
  const clamp=n=>Math.max(0,Math.min(1,n)),stops=[0,.23,.41,.975];
  const smooth=(start,end,value)=>{const t=clamp((value-start)/(end-start));return t*t*(3-2*t);};
  const props=new Map(), cleanups=[];
  let enabled=false,near=false,active=-1,target=0,progress=0,raf=0,previousTime=0,requested=0,drawn=-1;
  let dirty=true,layoutDirty=true,sceneTop=0,range=1,sectionHeight=1,documentTop=0,preloadTimer=0,disposed=false,inside=false;
  const listen=(object,event,fn,options)=>{object.addEventListener(event,fn,options);cleanups.push(()=>object.removeEventListener(event,fn,options));};
  function property(name,value){value=String(value);if(props.get(name)!==value){props.set(name,value);section.style.setProperty(name,value);}}
  function text(node,value){if(node.textContent!==value)node.textContent=value;}
  function select(index){
    if(active===index)return;active=index;
    chapters.forEach((chapter,i)=>{chapter.hidden=enabled&&i!==index;chapter.classList.toggle('is-active',enabled&&i===index);});
    buttons.forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));
  }
  function requestTick(){if(!raf&&!disposed&&!document.hidden)raf=requestAnimationFrame(tick);}
  let cutPrepared=false;
  function prepareCut(){if(cutPrepared)return;cutPrepared=true;for(const img of cutScene.querySelectorAll('img')){img.loading='eager';img.decoding='async';img.decode?.().catch(()=>{});}}
  function preload(){
    const rect=section.getBoundingClientRect();
    if(enabled&&!document.hidden&&rect.top<innerHeight+400&&rect.bottom>sceneTop){sequence.start();}
  }
  function layout(){
    layoutDirty=false;
    const next=!!context&&!reduced.matches&&!connection?.saveData&&!document.body.classList.contains('motion-off')&&innerHeight>=620;
    const changed=next!==enabled;enabled=next;
    const header=document.querySelector('#header-component'),nav=document.querySelector('[data-beam-product-nav]');
    sceneTop=Math.round(Math.min(110,header?.getBoundingClientRect().height||80)+(nav?.getBoundingClientRect().height||0));
    property('--scene-top',`${sceneTop}px`);section.classList.toggle('is-enhanced',enabled);
    documentTop=section.getBoundingClientRect().top+scrollY;
    sectionHeight=section.offsetHeight;range=Math.max(1,sectionHeight-stage.offsetHeight);
    if(changed||active<0){active=-1;select(0);}
    if(!enabled){
      sequence.pause();canvas.style.display='none';image.style.visibility='';drawn=-1;progress=target=0;previousTime=0;
      text(angle,'360°');text(status,'');property('--beam-scale','1');section.classList.remove('is-inside');inside=false;cutScene.removeAttribute('aria-hidden');
    }else if(changed){clearTimeout(preloadTimer);preloadTimer=setTimeout(preload,700);}
    dirty=true;
  }
  function paint(){
    sequence.prepare(requested);
    const frame=sequence.peek(requested);
    if(!frame||frame.index===drawn)return;
    // While a requested frame loads, never replace a closer view with a more distant one.
    const distance=i=>Math.min(Math.abs(i-requested),sequence.count-Math.abs(i-requested));
    if(drawn>=0&&distance(frame.index)>distance(drawn))return;
    const width=frame.image.width||frame.image.naturalWidth,height=frame.image.height||frame.image.naturalHeight;
    if(canvas.width!==width||canvas.height!==height){canvas.width=width;canvas.height=height;}
    context.clearRect(0,0,width,height);context.drawImage(frame.image,0,0);
    canvas.style.display='block';image.style.visibility='hidden';drawn=frame.index;
    canvas.dataset.frame=String(drawn);
    if(progress<.72)text(angle,`${String(Math.round(frame.index*360/sequence.count)).padStart(3,'0')}°`);
  }
  function tick(time){
    raf=0;if(disposed||document.hidden)return;
    if(layoutDirty)layout();if(!enabled)return;
    if(mobile&&previousTime&&time-previousTime<30){requestTick();return;}
    if(dirty){
      dirty=false;const top=documentTop-scrollY;target=clamp((sceneTop-top)/range);
      near=top<innerHeight+400&&top+sectionHeight>sceneTop;
      if(near)sequence.start();else sequence.pause();
    }
    if(!near){previousTime=0;return;}
    const dt=Math.min(50,previousTime?time-previousTime:16);previousTime=time;
    progress+=(target-progress)*(1-Math.exp(-dt/90));if(Math.abs(target-progress)<.0003)progress=target;
    const rotation=clamp((progress-.025)/.575);requested=Math.round(rotation*sequence.count)%sequence.count;
    const zoom=smooth(.60,.76,progress),bridge=smooth(.72,.81,progress),reveal=smooth(.83,.96,progress);
    select(progress<.17?0:progress<.32?1:progress<.79?2:3);
    property('--beam-copy-opacity',(progress<.79?1-smooth(.61,.68,progress):smooth(.79,.83,progress)).toFixed(4));
    property('--beam-zoom',zoom.toFixed(4));property('--beam-bridge',bridge.toFixed(4));property('--beam-reveal',`${(reveal*100).toFixed(3)}%`);
    property('--beam-scan-opacity',reveal>0&&reveal<1?.65:0);
    if(inside!==(progress>=.79)){inside=progress>=.79;section.classList.toggle('is-inside',inside);}
    if(cutScene.getAttribute('aria-hidden')!==String(!inside))cutScene.setAttribute('aria-hidden',String(!inside));
    if(progress>=.72)text(angle,progress<.83?'GROS PLAN':'INTÉRIEUR');
    property('--beam-progress',progress.toFixed(4));property('--beam-scale',(1+Math.sin(rotation*Math.PI)*.035+zoom*2.2).toFixed(4));
    if(progress>.58)prepareCut();
    paint();if(progress!==target)requestTick();else previousTime=0;
  }
  function update(){dirty=true;requestTick();}
  function resize(){layoutDirty=true;requestTick();}
  const unsubscribe=sequence.subscribe(()=>{
    if(!enabled||!near||document.hidden)return;
    text(status,sequence.failed?section.dataset.loadError || '':'');requestTick();
  });
  buttons.forEach((button,i)=>listen(button,'click',()=>{
    if(enabled)window.scrollTo({top:section.getBoundingClientRect().top+scrollY-sceneTop+range*stops[i],behavior:'smooth'});
  }));
  listen(window,'scroll',update,{passive:true});listen(window,'resize',resize,{passive:true});listen(window,'sl:navresize',resize);listen(reduced,'change',resize);
  if(connection?.addEventListener)listen(connection,'change',resize);
  const mutation=new MutationObserver(resize);mutation.observe(document.body,{attributes:true,attributeFilter:['class']});
  const observer=typeof ResizeObserver==='function'?new ResizeObserver(resize):null;
  for(const el of [section,stage,document.querySelector('#header-component'),document.querySelector('.sl-beam-cover')])if(el)observer?.observe(el);
  const hero=document.querySelector('.sl-beam-cover img');
  if(hero&&!hero.complete)listen(hero,'load',()=>{clearTimeout(preloadTimer);preloadTimer=setTimeout(preload,150);},{once:true});
  function openFromLink(){if(location.hash==='#immersion')requestAnimationFrame(()=>{if(disposed)return;if(layoutDirty)layout();window.scrollTo({top:section.getBoundingClientRect().top+scrollY-sceneTop,behavior:'instant'});update();});}
  listen(window,'load',()=>{resize();openFromLink();},{once:true});listen(window,'hashchange',openFromLink);
  listen(document,'visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0;previousTime=0;sequence.pause();}else{resize();preload();}});
  function destroy(){disposed=true;cancelAnimationFrame(raf);clearTimeout(preloadTimer);mutation.disconnect();observer?.disconnect();unsubscribe();for(const fn of cleanups)fn();sequence.destroy();canvas.remove();image.style.visibility='';}
  listen(window,'pagehide',event=>{if(event.persisted){sequence.pause();cancelAnimationFrame(raf);raf=0;}else destroy();});
  listen(window,'pageshow',()=>{resize();preload();});
  listen(document,'shopify:section:unload',event=>{if(event.target.contains(section))destroy();});
  document.fonts?.ready.then(()=>{if(!disposed)resize();});
  layout();requestTick();
})();

